import { makeStyles } from '@material-ui/core';
export const useEnhancedAutocompleteStyles = makeStyles({
    sectionHeader: {
        width: '100%',
        padding: '8px 0 4px',
        pointerEvents: 'none',
        // WHY: the header renders inside a disabled MUI option <li>; undo its dimming/hover so it reads as a label, not a faded option.
        'li[aria-disabled="true"]:has(&)': {
            opacity: 1,
            cursor: 'default',
            backgroundColor: 'transparent',
            pointerEvents: 'none'
        }
    },
    plainDisabledItem: {
        // WHY: opacity on the disabled row composites onto every descendant, so an itemRenderer cannot keep a badge or action at full strength by itself.
        '[aria-disabled="true"]:has(&)': {
            opacity: 1
        }
    }
});
